import { useEffect } from "react";
import { deleteOfertaDet, getOfertaDetPanel,getOfertaDetById } from "../../services/OfertasDetServices";
import { OfertasDetContext } from "./OfertasDetContext"

export const OfertasDetState = ({ children }) => {

    const getOfertaDetPanelData = async (aofid,searchArtId, numPagina, filas) => {
        let res = await getOfertaDetPanel(aofid,searchArtId, numPagina, filas)
        return res
    }

    const deleteOfertaDetData = async (body) => {
        const res = await deleteOfertaDet(body)
        if (res) getOfertaDetPanelData()
        return res
    }

    const getOfertaDetByIdData = async (id) => {
        let res = await getOfertaDetById(id)
        return res
    }


    return <OfertasDetContext.Provider value={{
        deleteOfertaDetData,
        getOfertaDetPanelData,
        getOfertaDetByIdData
    }} >
        {children}
    </OfertasDetContext.Provider>
}